'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var ndjson = require('iterable-ndjson');

var CID = require('cids');

var configure = require('../lib/configure');

var toIterable = require('stream-to-it/source');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, pin, _i, _Object$keys, cid;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (path && path.type) {
                options = path;
                path = null;
              }

              path = path || [];
              path = Array.isArray(path) ? path : [path];
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);
              searchParams.set('stream', options.stream == null ? true : options.stream);
              path.forEach(function (p) {
                return searchParams.append('arg', "".concat(p));
              });
              if (options.type) searchParams.set('type', options.type);
              _context.next = 10;
              return _awaitAsyncGenerator(ky.post('pin/ls', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams
              }));

            case 10:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 13;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 15:
              _context.next = 17;
              return _awaitAsyncGenerator(_iterator.next());

            case 17:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 21;
              return _awaitAsyncGenerator(_step.value);

            case 21:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 39;
                break;
              }

              pin = _value;

              if (!pin.Keys) {
                _context.next = 34;
                break;
              }

              _i = 0, _Object$keys = Object.keys(pin.Keys);

            case 26:
              if (!(_i < _Object$keys.length)) {
                _context.next = 33;
                break;
              }

              cid = _Object$keys[_i];
              _context.next = 30;
              return {
                cid: new CID(cid),
                type: pin.Keys[cid].Type
              };

            case 30:
              _i++;
              _context.next = 26;
              break;

            case 33:
              return _context.abrupt("return");

            case 34:
              _context.next = 36;
              return {
                cid: new CID(pin.Cid),
                type: pin.Type
              };

            case 36:
              _iteratorNormalCompletion = true;
              _context.next = 15;
              break;

            case 39:
              _context.next = 45;
              break;

            case 41:
              _context.prev = 41;
              _context.t0 = _context["catch"](13);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 45:
              _context.prev = 45;
              _context.prev = 46;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 50;
                break;
              }

              _context.next = 50;
              return _awaitAsyncGenerator(_iterator.return());

            case 50:
              _context.prev = 50;

              if (!_didIteratorError) {
                _context.next = 53;
                break;
              }

              throw _iteratorError;

            case 53:
              return _context.finish(50);

            case 54:
              return _context.finish(45);

            case 55:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 41, 45, 55], [46,, 50, 54]]);
    }));

    function ls(_x, _x2) {
      return _ls.apply(this, arguments);
    }

    return ls;
  }();
});